import { render, staticRenderFns } from "./SaleProductsReport.vue?vue&type=template&id=13418e07&"
import script from "./SaleProductsReport.vue?vue&type=script&lang=js&"
export * from "./SaleProductsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports